import React from 'react';


function Publications(props){
  return(
    <div className="container">
      <div className="row m-3">
        <div className="col-8">
          <h2>Papers</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-10">
          <h3>2019</h3>
          <ol>
            <li>
              <strong>Liver extracellular matrix providing dual functions of two dimensional substrate coating and three-dimensional injectable hydrogel platform for liver tissue engineering</strong>
              <br/>
              Contributors: Jung Seung Lee, Jisoo Shon, Hae-Min Park, Yun-Gon Kim, Byung-Gee Kim, Jong-Won Oh, and Seung-Woo Cho
              <br/>
              <a href="" download >[PDF]</a>
              <br/>
            </li>
            <li>
              <strong>Lipoteichoic acid of Enterococcus faecalis induces the expression of chemokines via TLR2 and PARF signaling pathways</strong>
              <br/>
              Contributors: OK-Jin Park, Ji Young Han, Jung Eun Baik, Jun Ho Jeon, Seok-Seong Kang, Cheol-Heui Yun, Jong-Won Oh, Ho Seuong Seo, and Seung Hyun Han
              <br/>
              <a href="" download >[PDF]</a>
              <br/>
            </li>
          </ol>
          <h3>2018</h3>
            <ol>
              <li>
                <strong>Liver extracellular matrix providing dual functions of two dimensional substrate coating and three-dimensional injectable hydrogel platform for liver tissue engineering</strong>
                <br/>
                Contributors: Jung Seung Lee, Jisoo Shon, Hae-Min Park, Yun-Gon Kim, Byung-Gee Kim, Jong-Won Oh, and Seung-Woo Cho
                <br/>
                <a href="" download >[PDF]</a>
                <br/>
              </li>
              <li>
                <strong>Lipoteichoic acid of Enterococcus faecalis induces the expression of chemokines via TLR2 and PARF signaling pathways</strong>
                <br/>
                Contributors: OK-Jin Park, Ji Young Han, Jung Eun Baik, Jun Ho Jeon, Seok-Seong Kang, Cheol-Heui Yun, Jong-Won Oh, Ho Seuong Seo, and Seung Hyun Han
                <br/>
                <a href="" download >[PDF]</a>
                <br/>
              </li>
            </ol>
            <h3>2017</h3>
            <ol>
              <li>
                <strong>Liver extracellular matrix providing dual functions of two dimensional substrate coating and three-dimensional injectable hydrogel platform for liver tissue engineering</strong>
                <br/>
                Contributors: Jung Seung Lee, Jisoo Shon, Hae-Min Park, Yun-Gon Kim, Byung-Gee Kim, Jong-Won Oh, and Seung-Woo Cho
                <br/>
                <a href="" download >[PDF]</a>
                <br/>
              </li>
              <li>
                <strong>Lipoteichoic acid of Enterococcus faecalis induces the expression of chemokines via TLR2 and PARF signaling pathways</strong>
                <br/>
                Contributors: OK-Jin Park, Ji Young Han, Jung Eun Baik, Jun Ho Jeon, Seok-Seong Kang, Cheol-Heui Yun, Jong-Won Oh, Ho Seuong Seo, and Seung Hyun Han
                <br/>
                <a href="" download >[PDF]</a>
                <br/>
              </li>
            </ol>
        </div>
      </div>
      <hr/>

      <div className="row m-3">
        <div className="col-8">
          <h2>Patents</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-10">
          <h3>2019</h3>
          <ol>
            <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex dicta, totam tenetur ab, laboriosam nostrum quisquam repellendus odio molestias distinctio fugit id, veniam velit cupiditate aliquam magni eveniet nam? Enim quos rem fugiat illum ex, nisi assumenda sint ad possimus minima illo reiciendis repellendus odit suscipit! Id enim sed eius!</li><br/>
            <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem impedit repudiandae sed, maxime obcaecati provident dignissimos molestiae soluta doloremque atque, placeat molestias fugiat corporis eveniet in sint rerum expedita pariatur. Quaerat enim eum quos et vel aut ea ex eos.</li><br/>
          </ol>
        </div>
      </div>
    </div>
  )
}


export default Publications